var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wordLimitActive)?_c('span',{class:("text-secondary " + (_vm.wordCountNum > _vm.wordLimitNum ? 'text-danger' : '') + " word-count-text")},[_vm._v(_vm._s(_vm.wordCount + "/" + _vm.wordLimit))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }